import { CreateFontPack, FontPack } from '@/types/theme-packs.types';
import { Post, Get, Put } from './helpers';

export const CreateFont = (fontPack: CreateFontPack): Promise<FontPack> => {
  return Post({ path: '/v3/admin/channel/fonts', body: fontPack });
};

export const GetFonts = (channel: number): Promise<FontPack[]> => {
  return Get({ path: `/v3/admin/channel/fonts/${channel}` });
};

export const GetFontName = (fontFileUrl: string): Promise<{ name: string }> => {
  return Put({
    path: `/v3/admin/channel/fonts/parse`,
    body: { url: fontFileUrl },
  });
};
